import {ChangeEvent, useState} from 'react';
import {Accordion, TextWithIcon} from '@legit-health/ui';
import ListAltIcon from '@mui/icons-material/ListAlt';
import {Box, TextField, Typography} from '@mui/material';
import {TFunction} from 'i18next';
import {AnamnesisQuestion} from '@/shared/interfaces/AnamnesisQuestion';
import {AnamnesisQuestionsValue} from '../../types';
import anamnesisSessionStorage from '../../utils/anamnesisSessionStorage';
import BottomBar from '../BottomBar';

export default function AnamnesisStep({
  activeStep,
  anamnesisQuestions,
  onBack,
  onNext,
  totalSteps,
  t,
  value: initialValue
}: {
  activeStep: number;
  anamnesisQuestions: AnamnesisQuestion[];
  onBack: () => void;
  onNext: (value: AnamnesisQuestionsValue) => void;
  totalSteps: number;
  t: TFunction;
  value: AnamnesisQuestionsValue;
}) {
  const [value, setValue] = useState(initialValue);

  function handleChange(event: ChangeEvent<HTMLInputElement>) {
    setValue(function (v) {
      const newValue = {
        ...v,
        [event.target.name]: event.target.value
      };
      anamnesisSessionStorage.set(newValue);
      return newValue;
    });
  }

  function handleNext() {
    onNext(value);
  }

  return (
    <>
      <Box
        sx={{
          maxWidth: 'md',
          mx: 'auto'
        }}
      >
        <Accordion
          id="anamnesis-question"
          expanded
          accordionSummary={
            <div>
              <TextWithIcon iconLeft={<ListAltIcon />} fontWeight="bold">
                {t('shared/common:diagnosticReport.form.anamnesisQuestions')}
              </TextWithIcon>
            </div>
          }
          accordionDetails={
            <Box
              sx={{
                mb: 2
              }}
            >
              {anamnesisQuestions.map((anamnesisQuestion, key) => (
                <Box
                  key={`anamnesis-question--${anamnesisQuestion.id}`}
                  sx={{
                    mt: key === 0 ? 0 : 2
                  }}
                >
                  <Typography
                    sx={{
                      mb: 0.5,
                      lineHeight: 1.5
                    }}
                    variant="body2"
                  >
                    {anamnesisQuestion.question}
                  </Typography>
                  <TextField
                    id={`${anamnesisQuestion.id}`}
                    type="text"
                    required
                    fullWidth
                    multiline
                    value={value[anamnesisQuestion.id]}
                    name={`${anamnesisQuestion.id}`}
                    onChange={handleChange}
                  />
                </Box>
              ))}
            </Box>
          }
        />
      </Box>
      <BottomBar
        activeStep={activeStep}
        isNextEnabled
        onBack={onBack}
        onNext={handleNext}
        totalSteps={totalSteps}
        t={t}
      />
    </>
  );
}
